import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-navy text-slate-400 py-12 border-t border-slate-800" data-id="element-7" data-mp="3gfiyctkyyvje">
      <div className="container mx-auto px-4" data-id="element-8" data-mp="32oe3e4sjqrfe">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-9" data-mp="32pfci3q053uh">
          <div className="col-span-1 md:col-span-2" data-id="element-10" data-mp="36qhgsyys063b">
            <Logo dark className="mb-4" data-id="element-11" data-mp="36n3c3k2n3ksp" />
            <p className="text-sm max-w-xs" data-id="element-12" data-mp="3ues8bbil0tex">
              Plataforma de inteligencia para licitaciones. Entiende cada
              documento mejor que tus competidores.
            </p>
          </div>

          <div data-id="element-13" data-mp="3ldamrdmenziu">
            <h3 className="text-white font-semibold mb-4" data-id="element-14" data-mp="3ldu52vfywpxe">Producto</h3>
            <ul className="space-y-2 text-sm" data-id="element-15" data-mp="3qcnkwuiq8t0q">
              <li data-id="element-16" data-mp="3qfji2gmr3do4">
                <a href="#como-funciona" className="hover:text-white transition-colors" data-id="element-17" data-mp="29z6ss7ftibds">
                  Cómo funciona
                </a>
              </li>
              <li data-id="element-18" data-mp="3l9acngdir03d">
                <a href="#para-quien" className="hover:text-white transition-colors" data-id="element-19" data-mp="3l8qx26bccnsi">
                  Casos de uso
                </a>
              </li>
              <li data-id="element-20" data-mp="3v8rfzr5at1w6">
                <a href="#ventaja" className="hover:text-white transition-colors" data-id="element-21" data-mp="3v9b09eif82dd">
                  Ventaja competitiva
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-22" data-mp="3474fms9a7yq">
            <h3 className="text-white font-semibold mb-4" data-id="element-23" data-mp="34gtn85h8b3d">Empresa</h3>
            <ul className="space-y-2 text-sm" data-id="element-24" data-mp="hstv2knc2m59">
              <li data-id="element-25" data-mp="hrs9hm8oyh9a">
                <a href="#vision" className="hover:text-white transition-colors" data-id="element-26" data-mp="hs1yb6i02ide">
                  Visión
                </a>
              </li>
              <li data-id="element-27" data-mp="qu1j89w4y6lm">
                <a href="#" className="hover:text-white transition-colors" data-id="element-28" data-mp="qr5i6cozr1sy">
                  Contacto
                </a>
              </li>
              <li data-id="element-29" data-mp="tvw6yepkdbex">
                <a href="#" className="hover:text-white transition-colors" data-id="element-30" data-mp="twfo3t7e3vrw">
                  Privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-sm flex flex-col sm:flex-row items-center justify-between" data-id="element-31" data-mp="13s9a037011mc">
          <p data-id="element-32" data-mp="18lk6pbi3k20j">
            © 2026{' '}
            <Link to="/styleguide" aria-label="Abrir el sistema de diseño de PRISMA" className="text-slate-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-cyan rounded-sm" data-id="element-33" data-mp="1clmabq7e75ig">
              PRISMA
            </Link>
            . Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}